import { Artboard, PrintPage, ASSETS } from "../components/nk/print/PrintKit";
import { ALTERATIONS, ALTERATION_STEPS } from "../data";

const Col = ({ children, style, className = "" }) => (
  <div className={`relative h-full flex-1 overflow-hidden ${className}`} style={style}>{children}</div>
);

export default function AlterationsBrochurePage() {
  return (
    <PrintPage
      pageW={313}
      pageH={226}
      title="Alterations tri-fold brochure — A4"
      subtitle="Two sides · 6 panels · 3 mm bleed + crop & fold marks"
      note="Print double-sided (flip on short edge) on A4, choose margins None + Background graphics. Letter-fold: fold the right panel in, then the left over it. Dashed ticks = fold lines."
    >
      {/* ===================== OUTSIDE ===================== */}
      <Artboard trimW={297} trimH={210} folds={[99, 198]} testid="alt-brochure-outside">
        <div className="pk-grain h-full w-full flex">
          {/* Back panel */}
          <Col style={{ padding: "12mm 9mm" }}>
            <div className="h-full flex flex-col">
              <img src={ASSETS.logoDark} alt="NK Bridal" style={{ height: "16mm", width: "auto" }} className="object-contain self-start" />
              <p className="text-[9px] uppercase tracking-[0.35em] text-ink/90 mt-[4mm]">NK Bridal Australia</p>
              <div className="mt-auto space-y-[2.5mm]">
                <p className="font-serif font-semibold italic text-ink" style={{ fontSize: "15pt" }}>Book your fitting.</p>
                <p className="text-ink" style={{ fontSize: "11pt" }}>0433 601 060</p>
                <p className="text-ink" style={{ fontSize: "9.5pt" }}>nkbridalaustralia@gmail.com</p>
                <p className="text-ink" style={{ fontSize: "9.5pt" }}>nkbridalaustralia.com.au</p>
                <p className="text-[8.5px] uppercase tracking-[0.25em] text-ink/90 pt-[2mm]">FB · Instagram · TikTok · @nkbridalaustralia</p>
                <p className="text-[8.5px] uppercase tracking-[0.25em] text-ink/90">Perth · Australia-wide</p>
              </div>
            </div>
          </Col>
          {/* Spine photo */}
          <Col>
            <img src={ASSETS.altMeasure} alt="bridal fitting" className="absolute inset-0 w-full h-full object-cover object-center" />
            <div className="absolute inset-0 bg-ink/40" />
            <p className="absolute bottom-[12mm] left-[8mm] right-[8mm] font-serif font-semibold italic text-ivory" style={{ fontSize: "16pt", lineHeight: 1.1 }}>
              A flawless fit, made by hand.
            </p>
          </Col>
          {/* Front cover */}
          <Col style={{ background: "#FDFBF7" }}>
            <div className="h-full flex flex-col items-center text-center" style={{ padding: "14mm 9mm" }}>
              <img src={ASSETS.logoDark} alt="NK Bridal" style={{ height: "26mm", width: "auto" }} className="object-contain" />
              <p className="text-[10px] uppercase tracking-[0.45em] text-ink/90 mt-[4mm]">NK Bridal Australia</p>
              <p className="font-serif font-semibold text-ink mt-[6mm]" style={{ fontSize: "24pt", lineHeight: 1.05 }}>
                Wedding <span className="italic">Alterations</span>
              </p>
              <p className="text-ink/95 font-semibold mt-[3mm]" style={{ fontSize: "10pt" }}>Expert bridal tailoring in Perth</p>
              <div className="mt-auto w-full relative overflow-hidden border border-line" style={{ height: "64mm" }}>
                <img src={ASSETS.altHem} alt="hemming a gown" className="w-full h-full object-cover object-center" />
              </div>
            </div>
          </Col>
        </div>
      </Artboard>

      {/* ===================== INSIDE ===================== */}
      <Artboard trimW={297} trimH={210} folds={[99, 198]} testid="alt-brochure-inside">
        <div className="pk-grain h-full w-full flex">
          {/* What we alter */}
          <Col style={{ background: "#F2EFE9" }}>
            <div className="h-full flex flex-col" style={{ padding: "12mm 9mm" }}>
              <p className="text-[9px] uppercase tracking-[0.35em] text-champagne">What we alter</p>
              <h3 className="font-serif font-semibold text-ink mt-[2mm]" style={{ fontSize: "20pt", lineHeight: 1 }}>Every detail</h3>
              <ul className="mt-[6mm] space-y-[3mm]">
                {ALTERATIONS.map((a) => (
                  <li key={a.t} className="flex items-start gap-2 text-ink" style={{ fontSize: "10pt" }}>
                    <span className="mt-[7px] block w-[8px] h-px bg-champagne shrink-0" />
                    <span><b className="font-semibold">{a.t}</b> — {a.d}</span>
                  </li>
                ))}
              </ul>
            </div>
          </Col>
          {/* How it works */}
          <Col style={{ background: "#FDFBF7" }}>
            <div className="h-full flex flex-col" style={{ padding: "12mm 9mm" }}>
              <p className="text-[9px] uppercase tracking-[0.35em] text-champagne">How it works</p>
              <h3 className="font-serif font-semibold text-ink mt-[2mm]" style={{ fontSize: "20pt", lineHeight: 1 }}>Four simple steps</h3>
              <div className="mt-[7mm] flex-1 flex flex-col gap-[6mm]">
                {ALTERATION_STEPS.map((s) => (
                  <div key={s.no} className="border-b border-line pb-[4mm]">
                    <div className="flex items-baseline gap-[4mm]">
                      <span className="font-serif font-semibold text-champagne" style={{ fontSize: "16pt" }}>{s.no}</span>
                      <span className="font-serif font-semibold text-ink" style={{ fontSize: "13pt" }}>{s.t}</span>
                    </div>
                    <p className="text-ink/95 font-semibold mt-[1.5mm]" style={{ fontSize: "9pt", lineHeight: 1.4 }}>{s.d}</p>
                  </div>
                ))}
              </div>
            </div>
          </Col>
          {/* Any gown welcome + CTA */}
          <Col className="bg-ink text-ivory">
            <div className="h-full flex flex-col" style={{ padding: "12mm 9mm" }}>
              <h3 className="font-serif font-semibold italic" style={{ fontSize: "22pt", lineHeight: 1 }}>Any gown, welcome</h3>
              <p className="text-ivory/75 font-semibold mt-[5mm]" style={{ fontSize: "10pt", lineHeight: 1.5 }}>
                Bought your dress elsewhere? No problem. Bridal, bridesmaid and formal wear are all tailored with the same couture care. Alterations are quoted individually at your first fitting — honest pricing, steaming and a final press included.
              </p>
              <div className="relative overflow-hidden border border-ivory/25 mt-[6mm]" style={{ height: "58mm" }}>
                <img src={ASSETS.altMeasure} alt="fitting" className="w-full h-full object-cover object-center" />
              </div>
              <div className="mt-auto pt-[4mm] border-t border-ivory/20">
                <p className="font-serif font-semibold italic" style={{ fontSize: "14pt" }}>Book your fitting today</p>
                <p className="text-ivory/70 mt-[2mm]" style={{ fontSize: "10pt" }}>0433 601 060 · nkbridalaustralia.com.au</p>
              </div>
            </div>
          </Col>
        </div>
      </Artboard>
    </PrintPage>
  );
}
